/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { makeStyles } from '@material-ui/core';
import { object, string, bool } from 'prop-types';
import { useSelector } from 'react-redux';
import { getFeatureFlag } from '../../../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const useStyles = makeStyles((theme) => ({
    wrapper: (styleData) => ({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '4px 8px',
        borderRadius: '3px',
        width: 'max-content !important',
        marginBottom: '8px',
        [theme.breakpoints.down(600)]: {
            padding: styleData.isFromPZComponent ? '3px' : '3px 8px',
        },
    }),
    content: (styleData) => ({
        fontFamily: 'Area Variable, Lato',
        fontWeight: '500',
        fontSize: '14px',
        lineHeight: '19px',
        letterSpacing: '0.5px',
        [theme.breakpoints.down(1080)]: {
            fontSize: styleData.isFromPZComponent ? '12px' : '14px',
        },
        [theme.breakpoints.down(600)]: {
            fontSize: styleData.isFromPZComponent ? '10px' : '12px',
            lineHeight: '16px',
        },
    }),
    icon: {
        marginRight: '6px',
        width: 'auto !important',
    },
    deliveryIcon: {
        width: '16px',
        height: '16px',
    },
}));
const DeliveryType = ({
    productDeliveryType, brand, productBrand, isFromPZComponent,
}) => {
    if (isFromPZComponent && !productDeliveryType) {
        return null;
    }
    const styleData = {
        isFromPZComponent,
    };
    const classes = useStyles(styleData);
    const deliveryTypeFlagText = useSelector(getFeatureFlag('is-delivery-type-collection-page-data-enabled'));
    const fptDeliveryType = deliveryTypeFlagText?.[brand?.domain]?.FPT || {};
    const gptDeliveryType = deliveryTypeFlagText?.[brand?.domain]?.GPT || {};
    const getDeliveryType = () => {
        if (productDeliveryType?.toLowerCase() === 'gpt') {
            return true;
        }
        return false;
    };
    const getDeliveryContent = () => {
        const productKey = String(productBrand);
        if (getDeliveryType()) {
            // If it's a GPT type and brand is 1026 or 1027, return the specific value
            if (gptDeliveryType?.[productKey]) {
                return gptDeliveryType[productKey] || 'Sent by a delivery partner';
            }
            return gptDeliveryType?.deliveryText || 'Sent by a delivery partner';
        }
        // If it's an FPT type and brand is 1026 or 1027, return the specific value
        if (fptDeliveryType?.[productKey]) {
            return fptDeliveryType[productKey] || 'Local florist delivery';
        }
        return fptDeliveryType?.deliveryText || 'Local florist delivery';
    };
    const iconGPT = () => (
        gptDeliveryType?.image
            ? <img src={gptDeliveryType?.image} alt="" className={classes.deliveryIcon} />
            : (
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                    <g id="gift">
                        <path id="Vector " fill-rule="evenodd" clip-rule="evenodd" d="M5.00033 2.50001C4.73511 2.50001 4.48075 2.60536 4.29322 2.7929C4.10568 2.98043 4.00033 3.23479 4.00033 3.50001C4.00033 3.76522 4.10568 4.01958 4.29322 4.20711C4.48075 4.39465 4.73511 4.50001 5.00033 4.50001H7.10301C7.02162 4.28708 6.9186 4.05295 6.79118 3.82128C6.37187 3.0589 5.79626 2.50001 5.00033 2.50001ZM2.66699 3.50001C2.66699 3.84923 2.74528 4.19039 2.89214 4.50001H1.33366C0.965469 4.50001 0.666992 4.79848 0.666992 5.16667V8.50001C0.666992 8.86819 0.965469 9.16667 1.33366 9.16667H2.00033V15.1667C2.00033 15.5349 2.2988 15.8333 2.66699 15.8333H7.99901L8.00033 15.8333L8.00164 15.8333H13.3337C13.7018 15.8333 14.0003 15.5349 14.0003 15.1667V9.16667H14.667C15.0352 9.16667 15.3337 8.86819 15.3337 8.50001V5.16667C15.3337 4.79848 15.0352 4.50001 14.667 4.50001H13.1085C13.2554 4.19039 13.3337 3.84923 13.3337 3.50001C13.3337 2.88117 13.0878 2.28767 12.6502 1.85009C12.2127 1.4125 11.6192 1.16667 11.0003 1.16667C9.46293 1.16667 8.53854 2.27444 8.04118 3.17873C8.02732 3.20394 8.0137 3.22913 8.00033 3.25428C7.98695 3.22913 7.97333 3.20394 7.95947 3.17873C7.46211 2.27444 6.53772 1.16667 5.00033 1.16667C4.38149 1.16667 3.78799 1.4125 3.35041 1.85009C2.91282 2.28767 2.66699 2.88117 2.66699 3.50001ZM8.89764 4.50001H11.0003C11.2655 4.50001 11.5199 4.39465 11.7074 4.20711C11.895 4.01958 12.0003 3.76522 12.0003 3.50001C12.0003 3.23479 11.895 2.98043 11.7074 2.7929C11.5199 2.60536 11.2655 2.50001 11.0003 2.50001C10.2044 2.50001 9.62878 3.0589 9.20947 3.82128C9.08205 4.05295 8.97903 4.28708 8.89764 4.50001ZM8.66699 5.83334V7.83334H13.3337H14.0003V5.83334H11.0003H8.66699ZM5.00033 5.83334H7.33366V7.83334H2.66699H2.00033V5.83334H5.00033ZM8.66699 14.5H12.667V9.16667H8.66699V14.5ZM7.33366 9.16667V14.5H3.33366V9.16667H7.33366Z" fill="#2F363D" />
                    </g>
                </svg>
            )
    );

    const iconFPT = () => (
        fptDeliveryType?.image
            ? <img src={fptDeliveryType?.image} alt="" className={classes.deliveryIcon} />
            : (
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
                    <g id="Group">
                        <path id="Vector (Stroke)" fill-rule="evenodd" clip-rule="evenodd" d="M1.42578 12.6852V6.01852H2.42578V12.6852C2.42578 12.9535 2.52729 13.2061 2.7005 13.3884C2.87288 13.5698 3.10105 13.6667 3.33319 13.6667H13.185C13.4172 13.6667 13.6453 13.5698 13.8177 13.3884C13.9909 13.2061 14.0924 12.9535 14.0924 12.6852V6.01852H15.0924V12.6852C15.0924 13.2027 14.8974 13.7038 14.5427 14.0771C14.1872 14.4513 13.6994 14.6667 13.185 14.6667H3.33319C2.8188 14.6667 2.331 14.4513 1.9755 14.0771C1.62083 13.7038 1.42578 13.2027 1.42578 12.6852Z" fill="#201648" />
                        <path id="Vector (Stroke)_2" fill-rule="evenodd" clip-rule="evenodd" d="M6.07999 8.33026C6.43549 7.95606 6.92329 7.74072 7.43768 7.74072H8.84509C9.35948 7.74072 9.84728 7.95606 10.2028 8.33026C10.5574 8.7036 10.7525 9.20472 10.7525 9.7222V14.1666H9.7525V9.7222C9.7525 9.45386 9.65099 9.20134 9.47778 9.01901C9.30539 8.83756 9.07723 8.74072 8.84509 8.74072H7.43768C7.20554 8.74072 6.97738 8.83756 6.80499 9.01901C6.63178 9.20134 6.53027 9.45386 6.53027 9.7222V14.1666H5.53027V9.7222C5.53027 9.20472 5.72532 8.7036 6.07999 8.33026Z" fill="#2F363D" />
                        <path id="Vector (Stroke)_3" fill-rule="evenodd" clip-rule="evenodd" d="M10.1807 0.333328L13.5696 0.333328C13.5695 0.333328 13.5696 0.333328 13.5696 0.333328C13.7765 0.333307 13.9749 0.404404 14.1347 0.531224C14.2941 0.657691 14.4059 0.831822 14.4582 1.02444L15.6494 5.41295C15.6846 5.53689 15.694 5.66682 15.6772 5.79433C15.6602 5.9236 15.6164 6.04872 15.5477 6.16087C15.4789 6.2731 15.3864 6.3703 15.2752 6.44425C15.1639 6.51827 15.0369 6.56684 14.9031 6.58506L14.8998 6.5855C14.59 6.62559 14.1579 6.66822 13.7051 6.6699C13.2593 6.67155 12.7581 6.63401 12.3268 6.49413C11.8416 6.33699 11.2574 5.98611 10.9855 5.81511L10.9832 5.81364C10.8593 5.7348 10.7576 5.62771 10.6844 5.5031C10.6115 5.37884 10.5685 5.23978 10.5576 5.09733C10.5575 5.09704 10.5575 5.09674 10.5575 5.09644L10.1807 0.333328ZM11.2629 1.33333L11.5522 4.99008C11.8337 5.16543 12.297 5.43339 12.635 5.54282C12.9187 5.6348 13.2974 5.6714 13.7013 5.66991C14.0512 5.66861 14.394 5.63914 14.6658 5.60686L13.5059 1.33333H11.2629Z" fill="#2F363D" />
                        <path id="Vector (Stroke)_4" fill-rule="evenodd" clip-rule="evenodd" d="M5.33429 0.333328H11.1842L11.5512 4.96838C11.5512 4.96888 11.5512 4.96938 11.5513 4.96988C11.5652 5.13832 11.5341 5.30847 11.4599 5.46154C11.3855 5.61523 11.2696 5.74743 11.1223 5.84015L11.1203 5.84138C10.8381 6.01727 10.2851 6.34358 9.82088 6.49413C9.26342 6.67492 8.76846 6.77407 8.25923 6.77407C7.74999 6.77407 7.25503 6.67492 6.69757 6.49413C6.23351 6.34362 5.68034 6.01727 5.39891 5.84261L5.39622 5.84094C5.24871 5.7481 5.13264 5.61563 5.05817 5.46164C4.98406 5.30841 4.95307 5.1381 4.96719 4.96956L5.33429 0.333328ZM6.25824 1.33333L5.9665 5.0178C6.25259 5.1934 6.68613 5.43914 7.00607 5.5429C7.49924 5.70285 7.88637 5.77407 8.25923 5.77407C8.63208 5.77407 9.01921 5.70285 9.51238 5.5429C9.83243 5.43911 10.2665 5.19303 10.5519 5.01719L10.2602 1.33333H6.25824Z" fill="#2F363D" />
                        <path id="Vector (Stroke)_5" fill-rule="evenodd" clip-rule="evenodd" d="M2.94836 0.333328C2.94832 0.333328 2.9484 0.333328 2.94836 0.333328L6.33725 0.333328L5.96039 5.09699C5.94958 5.23953 5.90672 5.3787 5.83388 5.5031C5.76074 5.628 5.65887 5.73533 5.53483 5.81433L5.5321 5.81606C5.26089 5.98632 4.67595 6.33716 4.19088 6.4942C3.75979 6.63356 3.25845 6.67118 2.8126 6.66953C2.3597 6.66785 1.92747 6.62521 1.61743 6.58466L1.61433 6.58425C1.48084 6.56593 1.35424 6.51743 1.24319 6.44362C1.13225 6.36988 1.03994 6.273 0.971238 6.16115C0.902577 6.04937 0.858693 5.92466 0.841395 5.79577C0.824287 5.66831 0.833389 5.53837 0.868353 5.41437L2.05966 1.0246C2.112 0.83198 2.2238 0.657693 2.38317 0.531224C2.54297 0.404403 2.7414 0.333307 2.94836 0.333328ZM3.01205 1.33333L1.85244 5.6063C2.12367 5.63876 2.46633 5.66824 2.81631 5.66954C3.22034 5.67103 3.5992 5.63451 3.88307 5.54276M3.01205 1.33333H5.25502L4.96567 4.99082C4.68465 5.16551 4.22106 5.43328 3.88307 5.54276" fill="#2F363D" />
                    </g>
                </svg>
            )
    );
    return (
        <div className={classes.wrapper} style={{ backgroundColor: deliveryTypeFlagText?.[brand?.domain]?.backgroundColor, color: deliveryTypeFlagText?.[brand?.domain]?.color }}>
            <div className={classes.icon}>
                {getDeliveryType() ? iconGPT() : iconFPT()}
            </div>
            <div className={`${classes.content} delivery-type-content`}> {getDeliveryContent()}</div>
        </div>
    );
};

DeliveryType.propTypes = {
    productDeliveryType: string.isRequired,
    brand: object.isRequired,
    productBrand: string.isRequired,
    isFromPZComponent: bool,
};

DeliveryType.defaultProps = {
    isFromPZComponent: false,
};

export default DeliveryType;
